import { Field } from 'formik';
import { BaseUrlParamsFilter, BaseUrlParamsFilterProps } from '../../../filters/base-url-params-filter';
import { CountryPicker } from 'shared/ui/formik-fields/country-picker';

interface CountryParamFilterProps extends BaseUrlParamsFilterProps {
  onCountryChange?: (value: string | null) => void;
}

export const CountryParamFilter = ({ 
  queryParamName, 
  size = 'medium',
  onCountryChange
}: CountryParamFilterProps) => {

  return (
    <BaseUrlParamsFilter queryParamName={queryParamName}>
      <Field 
        fullWidth 
        name={queryParamName} 
        label={'Страна'} 
        clearable={'true'} 
        size={size} 
        component={CountryPicker}
        onCountryChange={onCountryChange}
      />
    </BaseUrlParamsFilter>
  );
};
